import React from 'react';

function MenuItemSub({ onClick, title, icon }) {
  return (
    <a className="sidebar-header" href="#" onClick={onClick}>
      {icon}
      <span>{title}</span>
      <i className="fa fa-angle-right pull-right" />
    </a>
  );
}

MenuItemSub.propTypes = {};

export default MenuItemSub;
